export var SearchBarAttributes;
(function (SearchBarAttributes) {
    SearchBarAttributes["ICON_BUTTON_LABEL"] = "close search bar";
})(SearchBarAttributes || (SearchBarAttributes = {}));
//# sourceMappingURL=SearchBarProps.js.map